import api from "../services/api";
import { APIS } from "../endpoints";

/**
 * This function return songs data
 * @returns {Promise<Object>} - Function return Songs data
 */

export const getThemeObjectData = async (limit, page, searchTerm, filterOptions = {}) => {
    const response = await getThemeObjectAPIData(limit, page, searchTerm, filterOptions);
    return response;
};

const _isDefaultFilterOptions = (opts) => {
    if (!opts || typeof opts !== 'object') return true;
    const filters = opts.filters;
    const hasFilterValues = filters && typeof filters === 'object'
        && Object.values(filters).some((v) => Array.isArray(v) ? v.length > 0 : Boolean(v));
    if (hasFilterValues) return false;
    if (opts.search) return false;
    return true;
};

export const getThemeObjectAPIData = async (limit, page, searchTerm, filterOptions = {}) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (!_isDefaultFilterOptions(filterOptions)) {
        const cleanedOptions = {
            ...filterOptions,
            filters: Object.fromEntries(
                Object.entries(filterOptions.filters || {}).filter(([, v]) =>
                    Array.isArray(v) ? v.length > 0 : Boolean(v)
                )
            ),
        };
        formData.append('filters', JSON.stringify(cleanedOptions));
    }

    if (searchTerm) {
        formData.append('search', searchTerm);
    }

    if (filterOptions.sortBy_v) {
        formData.append('sort_by', filterOptions.sortBy_v);
    }

    if (filterOptions.sortOrder_v) {
        formData.append('sort_order', filterOptions.sortOrder_v);
    }

    const params = new URLSearchParams(formData);

    const result = await api.get(`${APIS.BASE_URL}${APIS.adminTheme}`, {
        params: params
    })
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};


export const getThemeBasicData = async (alias) => {

    const result = await api.get(`${APIS.BASE_URL}admin/theme/${alias}/${APIS.filmBasic}`)
    if (result) {
        return result?.data?.data;
    } else {
        return [];
    }
};

export const updateThemeBasicData = async (alias, data, deletedValues) => {

    const payload = {
        ...data,
        deletedValues: deletedValues
    };

    const result = await api.put(`${APIS.BASE_URL}admin/theme/${alias}/${APIS.filmBasic}`, payload)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

//Create theme preface data
export const getThemePrefaceData = async (alias, data) => {
    const result = await api.get(`${APIS.BASE_URL}admin/theme/${alias}/${APIS.filmPreface}`)
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

//Update theme preface data
export const updateThemePrefaceData = async (alias, data, deletedValues) => {
    const payload = {
        ...data,
        deletedValues: deletedValues
    };
    const result = await api.put(`${APIS.BASE_URL}admin/theme/${alias}/${APIS.filmPreface}`, payload)
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

//Get theme establishment data
export const getThemeEstablishmentData = async (alias) => {
    const result = await api.get(`${APIS.BASE_URL}admin/theme/${alias}/${APIS.filmEstablishment}`)
    if (result) {
        return result?.data?.data;
    } else {
        return [];
    }
};

//Update theme establishment data
export const updateThemeEstablishmentData = async (alias, data, deletedValues) => {
    const payload = {
        ...data,
        deletedValues: deletedValues
    };
    const result = await api.put(`${APIS.BASE_URL}admin/theme/${alias}/${APIS.filmEstablishment}`, payload)
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

//Get theme team data
export const getThemeTeamData = async (alias) => {
    const result = await api.get(`${APIS.BASE_URL}admin/theme/${alias}/introduction/team`)
    if (result) {
        return result?.data?.data;
    } else {
        return [];
    }
};

//Update theme team data
export const updateThemeTeamData = async (alias, data, deletedValues) => {
    const payload = {
        ...data,
        deletedValues: deletedValues
    };
    const result = await api.put(`${APIS.BASE_URL}admin/theme/${alias}/introduction/team`, payload)
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

//Get theme highlights data
export const getThemeHighlightsData = async (alias) => {
    const result = await api.get(`${APIS.BASE_URL}admin/theme/${alias}/introduction/highlights`)
    if (result) {
        return result?.data?.data;
    } else {
        return [];
    }
};

//Update theme highlights data
export const updateThemeHighlightsData = async (alias, data, deletedValues) => {
    const payload = {
        ...data,
        deletedValues: deletedValues
    };
    const result = await api.put(`${APIS.BASE_URL}admin/theme/${alias}/introduction/highlights`, payload)
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};